// test1792
(1792 && 0);
